// @ts-nocheck

export const DEFAULT_FLOATING_WTV_HEIGHT = 400;
